import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect, useMemo } from 'react';

import {
  AppointmentDeliveryMethod,
  GetAppointmentsForDeliveryDocument,
} from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { b2CloudDownloadModalState } from '~/state/reception/atoms';

// ページングなしで表示したいので、1日の最大予約受け入れ数 + 500を取得する
// 無限スクロールに置き換えても良さそう
const DEFAULT_PER_PAGE = 1500;
const B2CLOUD_DELIVERY_METHODS: AppointmentDeliveryMethod[] = [
  'b2cloud_cash_on_delivery',
  'b2cloud_collect',
  'b2cloud_compact',
  'b2cloud_compact_collect',
  'b2cloud_dm',
  'b2cloud_nekopos',
  'b2cloud_prepayment',
  'b2cloud_time',
];

export const useFetchAppointments = () => {
  const { isOpen } = useAtomValue(b2CloudDownloadModalState);

  const [getAppointments, { data, loading }] = useLazyQuery(GetAppointmentsForDeliveryDocument, {
    fetchPolicy: 'network-only',
  });
  const appointments = useMemo(
    () => (data ? getMe(data)?.organization.appointments.nodes || [] : []),
    [data],
  );

  useEffect(() => {
    if (isOpen) {
      getAppointments({
        variables: {
          page: 1,
          perPage: DEFAULT_PER_PAGE,
          statuses: ['status4'], // 配送済み
          deliveryMethods: B2CLOUD_DELIVERY_METHODS,
        },
      });
    }
  }, [getAppointments, isOpen]);

  return { loading, appointments };
};
